export const MenuRouteMap: Record<string, string> = {
  Dashboard: 'device-dashboard-page',
  'Government Servers': 'govt-servers',
  Fota: 'fota-batch',
  Ota: 'ota-batch-page',
  Model: 'model',
  'Customer Master': 'customer-master',
  'Dispatch Device': 'dispatch-device-page',
  'Production Device': 'production-device-page',
  'Sensorise SIM Data Details': 'sensorise-sim-data-details',
  'User Management': 'user-tab',
  'Role Management': 'user-role',
  'Role Group': 'role-group',
  'Dealers Management': 'dealers-management',
  'Dealers OTA': 'dealers-ota',
  'Sampark EOL': 'sampark-eol-page',
};
